export const XInCircle: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#0B564C",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    color={color}
    {...rest}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="m11.36 6.64-4.717 4.717M11.36 11.357 6.642 6.641M9 16.5A7.5 7.5 0 0 1 1.5 9 7.5 7.5 0 0 1 9 1.5 7.5 7.5 0 0 1 16.5 9 7.5 7.5 0 0 1 9 16.5"
    ></path>
  </svg>
);
